<template>
  <roe-error-message
    :field="design.plan_has_employer_matching_contributions_picklist_id"
  >
    <v-select
      v-model="
        design.$model.plan_has_employer_matching_contributions_picklist_id
      "
      :options="[
        { code: 0, label: 'No' },
        { code: 1, label: 'Yes, Same Formula for All Employees' },
        { code: 2, label: 'Yes, Formula Varies by Type of Employee' }
      ]"
      :reduce="label => label.code"
      @input="
        resetAttributes(
          design,
          'plan_has_employer_matching_contributions_picklist_id'
        )
      "
    >
    </v-select>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeEmployerMatchSelect",
  mixins: [ResetDesignAttributesMixin],
  components: { RoeErrorMessage },
  props: {
    design: Object
  }
};
</script>
